import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DefaulToolbarClickHandlerService } from './defaul-toolbar-click-handler.service';
import { ErrorHandlerComponent } from './error-handler/error-handler.component';
import { AsyncGridPipe } from './async-grid.pipe';
import { GridLoadedDirective } from './grid-loaded.directive';
import { DropdownLoadedDirective } from './dropdown-loaded.directive';



@NgModule({
  declarations: [ErrorHandlerComponent, AsyncGridPipe, GridLoadedDirective, DropdownLoadedDirective],
  imports: [
    CommonModule
  ],
  providers: [
    DefaulToolbarClickHandlerService
  ],
  exports: [ErrorHandlerComponent, GridLoadedDirective, DropdownLoadedDirective]
})
export class UtilsModule { }
